import { T } from 'react-translator-component';
interface SelectProps {
  value: string;
  label: string;
  id: string;
}

export const parserStationGroupsForSelect = (
  stationGroups: any[],
): SelectProps[] | any => {
  const allStationGroups = {
    value: '',
    id: 'BVGHIHJKBHVHJJB*&ˆ',
    label: T('All Chargebox Groups'),
  };

  return (
    stationGroups && [
      allStationGroups,
      ...stationGroups.map((stationGroup) => ({
        value: stationGroup.chargeBoxGroupPk,
        label: stationGroup.name || 'Grupo sem nome',
        id: stationGroup.chargeBoxGroupPk + stationGroup.name,
      })),
    ]
  );
};

export const parserTenantsForSelect = (tenants: any[]): SelectProps[] | any => {
  const allTenants = {
    value: '',
    id: 'HVGHIHJKBHVHJJB*&ˆ',
    label: T('All Accounts'),
  };

  return (
    tenants && [
      allTenants,
      ...tenants.map((tenant) => ({
        value: tenant.tenant_pk,
        label: tenant.name || T('Unnamed Account'),
        id: tenant.tenant_pk + tenant.name,
      })),
    ]
  );
};

export const parserStatusForSelect = (status: any[]): SelectProps[] | any => {
  const allStatus = {
    value: '',
    id: 'XVGHIHJKBHVHJJB*&ˆ',
    label: T('All Stations'),
  };
  return (
    status && [
      allStatus,
      ...status.map((statusItem) => ({
        value: statusItem.value,
        label: statusItem.description,
        id: statusItem.id,
      })),
    ]
  );
};
